export const showerBaseHeightMM = 30;

export const isShowerBaseId = (baseId: string): boolean => {
    return baseId !== '0';
};
